import "@Styles/Shared/ProductInfo/ImageModal/imageModal_lg.less";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import modal from '@Shared/Common/Scripts/Components/modalBase';
export default {
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    images: Array,
    parentSelectedIndex: Number,
    imageModalHeading: String,
    imageModalLabel: String
  },
  data: function data() {
    return {
      selectedIndex: this.parentSelectedIndex
    };
  },
  components: {
    'modal': modal
  },
  computed: {
    selectedImage: function selectedImage() {
      if (this.selectedIndex >= 0 && this.selectedIndex < this.images.length) {
        return this.images[this.selectedIndex];
      } else {
        return {};
      }
    },
    navigationTitle: function navigationTitle() {
      return this.imageModalLabel != null ? this.imageModalLabel.replace('{0}', this.images.length.toString()) : '';
    }
  },
  mounted: function mounted() {
    // Apply focus to the current thumbnail element
    this.$refs.thumbnails[this.selectedIndex].firstChild.focus();
  },
  methods: {
    close: function close() {
      this.$emit('close');
    },
    focusStart: function focusStart() {
      this.$refs.buttons && this.$refs.buttons[this.selectedIndex] && this.$refs.buttons[this.selectedIndex].focus();
    },
    previous: function previous() {
      this.selectImage(this.selectedIndex - 1);
    },
    next: function next() {
      this.selectImage(this.selectedIndex + 1);
    },
    selectImage: function selectImage(index) {
      if (index >= 0 && index < this.images.length) {
        // only change if index is in range
        this.selectedIndex = index;
      }
    }
  }
};